const premium = {
  signup: "Suscríbase hoy",
  already_enrolled: "Ya registrado",
  intro: {
    title: "Membresía PODERsalud",
    subtitle: "Revise los beneficios incluidos en su suscripción:",
    trusted_advisor: "Asesoría prioritaria",
    exclusive_content: "Recompensas exclusivas",
    medical_discounts_subtitle: "Ahorre con descuentos médicos en servicios como:"
  },
  benefits: {
    teladoc: "Telemedicina",
    vision: "Visión",
    hearing: "Ayuda auditiva",
    mri: "Rayos X",
    travel: "Turismo descontado",
    lab: "Análisis clínicos",
    diabetic: "Diabetes",
    pharmacy: "Farmacia",
    dental: "Dentista",
  },
  personal_info: {
    title: "Perfil",
    subtitle: "Rellene los campos a continuación. Sus datos se almacenan con los más altos estándares de seguridad.",
  },
  address: {
    title: "Domicilio",
    subtitle: "Rellene los campos a continuación. Sus datos se almacenan con los más altos estándares de seguridad.",
  },
  payment: {
    annual_membership: "Membresía anual",
    title: "Forma de pago",
    subtitle: "Seleccione cómo le gustaría pagar para empezar a disfrutar sus beneficios",
    coupon: "Cupón",
    redeem: "Redimir",
    plan: "Tipo de plan:",
    membership: "Membresia premium",
    monthly_membership: "Membresía mensual",
    monthly: "Mensual",
    price: "Precio",
    duration: "mes",
    credit_card_number: "Número de tarjeta",
    expiry: "Expiración mm/aa",
    cvv: "CVV",
    confirm_purchase: "Confirmar compra",
    failure_title: "¡Uh-oh!",
    product_name: "Membresía Premium",
    or: "O",
    pay_with_card: "pague con tarjeta",
    update_and_pay: "Actualizar + Pagar",
    update: "Actualizar",
    yearly: "Anual",
  },
  steps: {
    benefits: "Beneficios",
    personal: "Perfil",
    address: "Domicilio",
    payment: "Pago",
  },
  disclaimer:
    "Inscripción para plan de descuento. Este programa NO ES una póliza de seguros, la intención NO ES reemplazar a su compañía de seguros, y tampoco cumple con los requisitos mínimos de cobertura que piden el Affordable Care Act o el M.G.L. c. 111M y 956 CRM 5.00 de Massachusetts. Su membresía es efectiva desde la recepción de los materiales de membresía. Este programa no está disponible para residentes de UT, VT o WA. Tras inscribirse, Tendrá 30 días para evaluar el servicio y si no queda satisfecho en ese período, puede cancelar el programa sin costo alguno y le devolveremos su dinero. Los descuentos los puede utilizar sólo en las oficinas de los proveedores de servicios médicos que forman parte de la red, y cada titular de la membresía tiene la obligación de pagar los servicios descontados en el momento en el que se reciben. Para una lista completa de los términos y condiciones, haga clic aquí. Discount Plan Organization: New Benefits, Ltd., Attn: Compliance Department, PO Box 803475, Dallas, TX 75380-3475. Formulario # HPSEP2",
  not_available: "Lo sentimos, este producto no está disponible en su estado.",
  billing: {
    billing: "Pago",
    update_now: "Actualizar",
    edit_payment: "Editar",
  },
  past_due: {
    status_message: "El pago de su suscripción a PODERsalud no pasó. Por favor consulte el saldo de su tarjeta y actualice su método de pago.",
    success_title: "Felicidades",
    success_message: "Su pago se ha procesado correctamente y la información de su tarjeta se ha actualizado.",
  },
  update_payment: {
    success_title: "Felicidades",
    // TODO: This is probably wrong.  We don't have copy for this in proton
    success_message: "La información de su tarjeta se ha actualizado.",
  },
  success: {
    congratulations: "",
    title1: "¡Le damos la bienvenida a PODERsalud!",
    title2: "Recibirá información en su correo sobre cómo acceder sus beneficios.",
    dismiss: "Cerrar",
  },
  coupon: {
    placeholder: "Añadir cupón",
    success: {
      title: "¡Éxito!",
      message: "Su cupón ha sido redimido",
    },
    error: {
      title: "¡Uh-oh!",
      message: "Código de Cupón Incorrecto",
    },
    redeem: "Redimir",
    payment_one: "pago",
    payment_other: "{{ count }} pagos",
    coupon_applied: "¡Felicidades! Recibirá un descuento del {{ discount }} en sus primeros {{ duration }}",
  },
  landing: {
    main: {
      title: "PODERsalud",
      subtitle: "¡Los descuentos médicos de PODERsalud y más!",
      caption: "Más oportunidades para ahorrar, aprender y crecer",
      cta: "Regístrate hoy"
    },
    about: [
      {
        title: "Una membresía, múltiples beneficios",
        text: "SEP+ es el programa de suscripción que le da más. Más ahorros en gastos médicos, más velocidad de respuesta a sus preguntas, más contenidos para empoderar a nuestra comunidad, ¡y más!"
      },
      {
        title: "Pague la membresía con los ahorros generados",
        text: "SEP+ le incluye PODERsalud, un plan de descuentos médicos que le ahorra 10-80% en medicinas y servicios médicos. Por ejemplo: una familia de cuatro ahorra más de $2000 al año*. ¡Verá que la mensualidad se paga sola!"
      },
      {
        title: "Suscripción pensada para la comunidad",
        text: "Toda la comunidad es elegible. No importa si recién se integró a SEP o si forma parte de la comunidad desde hace tiempo. La suscripción a SEP+ es para todas las personas en busca de gastar menos, ahorrar más y vivir mejor."
      }
    ],
    information: {
      title: "Beneficios imparables",
      items: [
        {
          key: 'medical',
          title: "Acceso instantáneo a plan de descuentos médicos<span>.</span>",
          text: "Plan de descuentos médicos que incluye consultas médicas por teléfono o videollamada cuando las requiera, descuentos de <span>10-80%</span> en medicamentos, <span>15-50%</span> en dentistas, y más."
        },
        {
          key: 'chat',
          title: "Reciba la ayuda que necesita más rápido<span>.</span>",
          text: "Reciba ayuda en tiempo real cuando sea, ¡desde dónde sea! Con el servicio Asesoría de Confianza de SEP+, envíe sus preguntas por el Chat y reciba respuestas antes que otras personas."
        },
        {
          key: 'exclusive',
          title: "Contenidos exclusivos de SEP+ (próximamente)<span>.</span>",
          text: "Sabemos que la información es clave para su desarrollo. Con SEP+, acceda a guías y contenidos exclusivamente disponibles para suscriptores. ¡Próximamente!",
        }
      ]
    },
    testimonial: {
      title: "Ya somos <span>3+ millones</span> de personas",
      items: [
        {
          image: "https://images.contentstack.io/v3/assets/blt224b6cd2a9d5dbf3/bltf6582111a1580cb4/623e0c8f7c24b44cb0bf4988/jose.png",
          name: "Jose",
          location: "Miami, FL",
          text: "Les recomiendo PODERsalud a todas las personas que no tengan seguro médico. Con este programa, el cuidado de la salud es más barato. Además, son una excelente compañía.",
        },
        {
          image: "https://images.contentstack.io/v3/assets/blt224b6cd2a9d5dbf3/blt7f1b1c137f18f036/62420afb7239af5fef4139a8/angela.png",
          name: "Angela",
          location: "Chicago, IL",
          text: "Contacté al equipo de PODERsalud para solicitar una consulta por video y recibimos un diagnóstico de inmediato. Fue increíble.",
        },
        {
          image: "https://images.contentstack.io/v3/assets/blt224b6cd2a9d5dbf3/bltcad0bdfd67c65c5a/62420afb1cb34d6f0a56f85e/maria.png",
          name: "Maria",
          location: "Los Angeles, CA",
          text: "¡He pertenecido a SABEResPODER durante años y siento que cada vez que visito el sitio hay algo nuevo qué explorar! Me encanta la cantidad de contenido útil que hay para explorar y aprender.",
        }
      ]
    },
    faq: {
      title: "Preguntas frecuentes",
      items: [
        {
          title: "¿Para qué sirve PODERsalud?",
          htmlContent: "<p>PODERsalud le apoya de tres maneras cruciales: </p> <ol> <li>Le brinda acceso a servicios médicos incluyentes y de bajo costo.</li>  <li>Puede hacer preguntas a nuestro Equipo de Atención al Cliente cuando quiera y sobre lo que quiera.</li> <li> Descubrirá información valiosa sobre cientos de temas que le ayudará a tomar decisiones informadas, ahorrar tiempo y dinero.</li> </ol>"
        },
        {
          title: "¿Mi familia puede recibir beneficios con estos descuentos?",
          htmlContent: "¡CORRECTO! Los beneficios de PODERsalud se extienden a usted, su pareja y dependientes menores de 26 años."
        },
        {
          title: "¿Qué pasa si quiero cancelar la suscripción?",
          htmlContent: "Cancelar es fácil. Para nosotros es importante ofrecer servicios que sean fáciles de usar y aún más de cancelar. Si necesita hacer algún cambio en su suscripción, lo puede hacer en cualquier momento."
        },
      ]
    },
    fineprint: "*Este es un ejemplo de los ahorros que se pueden generar y no representa una garantía de ahorros específicos en todos los casos. Los costos y ahorros pueden variar con base en el servicio, proveedor y área geográfica."
  },
  appointment: {
    book_appointment_cta: "Hacer una cita",
    book_appointment_instruction: "Llame al siguiente número para reservar una cita"
  },
  annual: {
    billed_annually: "Un solo cobro <strong>anual</strong>",
    billed_monthly: "Cobro <strong>mensual</strong>",
    discount_percentage: "{{ discount }}% de descuento",
    months_free: "{{ number }} meses gratis",
    no_discount: "Sin discuento",
    pay_full_price: "Pagar sin descuento",
    per_month: "/ mes",
    per_year: "/ año",
  },
  missed_payment: {
    header: "¡Ups! Su pago no pasó",
    text_content: "Para seguir usando los beneficios de PODERsalud debe actualizar los datos de pago.",
    banner_text_content: "No pudimos procesar su pago. Puede reactivar su suscripción actualizando el método de pago.",
    close_cta: "Cerrar",
    update_now_cta: "Actualizar",
  }
};

export default premium;
